import api from '../resources/subordinate-list.api';
import actionTypes from './action-types';

export const fetchSubordinateListRequest = () => ({
  type: actionTypes.FETCH_SUBORDINATE_LIST_REQUEST,
  name: 'subordinateListLoadingStatus',
});

export const fetchSubordinateListSuccess = (list, pagination) => ({
  type: actionTypes.FETCH_SUBORDINATE_LIST_SUCCESS,
  list,
  pagination,
  name: 'subordinateListLoadingStatus',
});

export const fetchSubordinateListFailure = () => ({
  type: actionTypes.FETCH_SUBORDINATE_LIST_FAILURE,
  name: 'subordinateListLoadingStatus',
});

export const fetchSubordinateList = (params) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = params.retailerId || session.retailer.retailerId;

    const requestParams = {
      ...params,
      retailerId,
    };

    dispatch(fetchSubordinateListRequest());

    const { content: list, ...pagination } = await api.fetchSubordinateList(requestParams);
    dispatch(fetchSubordinateListSuccess(list, pagination));
  } catch (error) {
    console.error('FETCH_SUBORDINATE_LIST', error);
    dispatch(fetchSubordinateListFailure());
  }
};

export const selectRetailer = (retailer) => ({
  type: actionTypes.SELECT_RETAILER,
  retailer,
});



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/actions/subordinate-list.actions.js